import { Breadcrumbs, Grid2, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export interface BreadcrumbElement {
  label: string;
  href: string;
}

interface HeaderBreadcrumbsProps {
  breadcrumbElements: BreadcrumbElement[];
}
const HeaderBreadcrumbs: React.FC<HeaderBreadcrumbsProps> = ({
  breadcrumbElements,
}) => {
  return (
    <Grid2 container sx={{ display: "flex" }}>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{ color: "gray", fontSize: "14px" }}
      >
        {Boolean(breadcrumbElements) &&
          breadcrumbElements.map(
            (element: { href: any; label: any }, i: any) => {
              return element.href ? (
                <Link
                  key={i}
                  underline="hover"
                  color="inherit"
                  component={RouterLink}
                  to={element.href}
                  sx={{ color: "gray" }}
                >
                  {element.label}
                </Link>
              ) : (
                <Typography key={i} sx={{ color: "white" }}>
                  {element.label}
                </Typography>
              );
            }
          )}
      </Breadcrumbs>
    </Grid2>
  );
};

export default HeaderBreadcrumbs;
